<div class="nm-list-card mb-3">
  <img src="{{ card.image }}" alt="{{ card.title }}" class="nm-rounded" />
  <div>
    <p class="nm-secondary">{{ card.title }}</p>
    <h6 class="fw-bolder">{{ card.description }}</h6>
  </div>
</div>
